import Vue from 'vue'
// 引入BootstrapVue
import {BootstrapVue, IconsPlugin} from 'bootstrap-vue'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
// 引入 elementUI
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import App from './App.vue'
// 引入路由
import router from "./router"
// 引入vuex
import store from "@/utils/store";
// 引入cookie
import VueCookies from 'vue-cookies'
// 语法配置
import 'babel-polyfill';
import Es6Promise from 'es6-promise';
import permission from './permission'
import _ from 'lodash'

Vue.prototype.$cookies = VueCookies
Vue.prototype.$ftpUrl = window.g.ftpUrl

Vue.prototype.$stringIsNotNullAndEmpty = function (str) {
  if (!str || str.toString().trim().length <= 0) {
    return false;
  }
  return true;
};

Vue.prototype._ = _

//数字校验大于0的正整数
Vue.prototype.$checkNumber = function (str) {
  var reg = /^\+?[1-9][0-9]*$/;  // 大于0的正整数
  if (!reg.test(str)) {
    return false;
  }
  return true;
};

Es6Promise.polyfill()

Vue.config.productionTip = false

Vue.use(ElementUI);
Vue.use(BootstrapVue)
Vue.use(IconsPlugin)
Vue.use(permission)

new Vue({
  render: h => h(App),
  store, // 使用 this.$store访问
  router,
}).$mount('#app')
